<template>
  <div>
    <v-btn icon class="ml-1 mr-5" @click.stop="dialog = true">
      <v-icon large>mdi-help-circle-outline</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title class="headline">EO Clinic Gaza</v-card-title>

        <v-card-text>
          <p>
            Click on the checkbox in the left menu, to see the layer in the
            map.<br />Move the map with the left mouse button. You can change
            the angle of the map view with the right mouse button.
          </p>
          <p>
            Hover over the Shorelines to see the associated date.<br />
            By clicking on the individual features for Net Shoreline Movement
            and the Change Rate you will see a popup with the actual value.
          </p>
          <p>
            If you have further questions, don't hesitate contacting us via
            email or phone:
          </p>

          <p>
            Email:
            <a href="mailto: info@example.com?subject=EoPortal Question"
              >Info@eomap.de</a
            >
          </p>
          <p>Phone: +49 (0) 8152 9986 110</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "HelpMenu",
  data() {
    return {
      dialog: false
    };
  }
};
</script>

<style scoped></style>
